import { API_CONFIG } from './api';
import type { PepProfile } from './pepProfile';
import { getTenantHeaders } from '@/config/tenant';

export type PepGenerateRequest = {
  tenantId: string;
  leadId: string;
  programId?: string;
  contact: Record<string, unknown>;
  signals: Record<string, unknown>;
  request: Record<string, unknown>;
  pepProfile?: PepProfile;
};

export async function generatePepJob(
  payload: PepGenerateRequest,
  options?: {
    forceRegenerate?: boolean;
    startSequence?: boolean;
  }
) {
  if (!API_CONFIG.MESSENGER_API) {
    throw new Error('PEP service not configured');
  }
  const res = await fetch(`${API_CONFIG.MESSENGER_API}/generate`, {
    method: 'POST',
    headers: getTenantHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      context: payload,
      forceRegenerate: options?.forceRegenerate !== false,
      startSequence: options?.startSequence === true,
    }),
  });
  if (!res.ok) {
    throw new Error(`PEP API error: ${res.status}`);
  }
  return res.json();
}

export async function getPepJob(jobId: string) {
  if (!API_CONFIG.MESSENGER_API) {
    throw new Error('PEP service not configured');
  }
  const res = await fetch(`${API_CONFIG.MESSENGER_API}/generate/${encodeURIComponent(jobId)}`, {
    headers: getTenantHeaders(),
  });
  if (!res.ok) {
    throw new Error(`PEP API error: ${res.status}`);
  }
  return res.json();
}

export async function getPepLatest(tenantId: string, leadId: string) {
  if (!API_CONFIG.MESSENGER_API) {
    throw new Error('PEP service not configured');
  }
  const params = new URLSearchParams({ tenantId, leadId });
  const res = await fetch(`${API_CONFIG.MESSENGER_API}/latest?${params.toString()}`, {
    headers: getTenantHeaders(),
  });
  if (!res.ok) {
    throw new Error(`PEP API error: ${res.status}`);
  }
  return res.json();
}

export async function getPepRunStatus(params: { tenantId: string; leadId?: string; runId?: string }) {
  if (!API_CONFIG.MESSENGER_API) {
    throw new Error('PEP service not configured');
  }
  const endpoint = params.runId
    ? `${API_CONFIG.MESSENGER_API}/run/${encodeURIComponent(params.runId)}`
    : `${API_CONFIG.MESSENGER_API}/run?${new URLSearchParams({
        tenantId: params.tenantId,
        ...(params.leadId ? { leadId: params.leadId } : {}),
      }).toString()}`;
  const res = await fetch(endpoint, {
    headers: getTenantHeaders(),
  });
  if (!res.ok) {
    throw new Error(`PEP API error: ${res.status}`);
  }
  return res.json();
}
